var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAccountCircleOffFill = function SvgAccountCircleOffFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480-160q43 0 84-11.5t78-33.5L487-360h-7q-67 0-130 21.5T234-276q50 55 110 85.5T480-160M791-57l-90-89q-49 32-105 49T480-80q-83 0-156-31.5T197-197t-85.5-127T80-480q0-59 16.5-115T145-701l-90-91q-12-12-11.5-28.5T56-849t28.5-12 28.5 12l735 736q12 12 12 28t-12 28-28.5 12T791-57m23-203L586-488q17-19 25.5-42.5T620-580q0-58-41-99t-99-41q-26 0-49.5 8.5T388-686L260-814q49-32 105-49t115-17q83 0 156 31.5T763-763t85.5 127T880-480q0 59-17 115t-49 105"
  })));
};
export default SvgAccountCircleOffFill;